/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentPlanMarketingTile
 */
export interface PaymentPlanMarketingTile {
    /**
     * Short tile heading.
     * @type {string}
     * @memberof PaymentPlanMarketingTile
     */
    title: string;
    /**
     * Supporting copy for the tile.
     * @type {string}
     * @memberof PaymentPlanMarketingTile
     */
    body?: string;
    /**
     * Client-side icon identifier for the tile.
     * @type {string}
     * @memberof PaymentPlanMarketingTile
     */
    icon?: string;
}

/**
 * Check if a given object implements the PaymentPlanMarketingTile interface.
 */
export function instanceOfPaymentPlanMarketingTile(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function PaymentPlanMarketingTileFromJSON(json: any): PaymentPlanMarketingTile {
    return PaymentPlanMarketingTileFromJSONTyped(json, false);
}

export function PaymentPlanMarketingTileFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentPlanMarketingTile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'body': !exists(json, 'body') ? undefined : json['body'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
    };
}

export function PaymentPlanMarketingTileToJSON(value?: PaymentPlanMarketingTile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'body': value.body,
        'icon': value.icon,
    };
}

